import request from "@/utils/request";

export async function loginUserLogin(params) {
  console.log("登录请求参数：", params);
  return request({
    url: "/Login/UserLogin",
    method: "post",
    data: params,
  });
}

// 退出登录
export async function UserLogout(params) {
  return request({
    url: "/Login/UserLogout",
    method: "post",
  });
}

//渠道用户账户登录
export async function LoginChannel(data) {
  return request({
    url: "/Login/LoginChannel",
    method: "post",
    data: data,
  });
}

//发送短信验证码
export async function SendSmsCode(data) {
  return request({
    url: "/Login/SendSmsCode",
    method: "post",
    data: data,
  });
}

//手机验证码登录
export async function PhoneLogin(data) {
  return request({
    url: "/Login/PhoneLogin",
    method: "post",
    data: data,
  });
}

//获取账户登录图形验证码
export async function QueryLoginVerifyCode() {
  return request({
    url: "/Login/QueryLoginVerifyCode",
    method: "get",
  });
}
